// Dependencies
import styled from 'styled-components';

const BlogPostImagesStyles = styled.div`
  .wrapper {
    display: grid;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .caption {
    margin-top: 0.7rem;
    font-size: 0.8rem;
    text-align: center;
    opacity: 0.6;
  }

  @media (min-width: 768px) {
    .wrapper {
      grid-template-columns: 1fr ${(props) => (props?.duo ? '1fr' : '')};
    }

    .caption {
      font-size: 1rem;
    }
  }
`;

export default BlogPostImagesStyles;
